/**
 * Export-to-Excel button. POSTs the active filter + sort to /api/volunteers/export
 * and streams the xlsx download. Hidden/disabled unless refs.canSeeExcelExport.
 */

import { useMutation } from "@tanstack/react-query";
import { Download } from "lucide-react";

import { exportVolunteers } from "@/api/client";
import { useRefs } from "@/api/hooks";
import { useFilters } from "@/store/filters";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";

export function ExportButton() {
  const { data: refs } = useRefs();
  const filters = useFilters((s) => s.filters);
  const sort = useFilters((s) => s.sort);

  const exportMutation = useMutation({
    mutationFn: () => exportVolunteers(filters, sort),
  });

  // Hide entirely when refs are loaded and export is not permitted.
  if (refs && !refs.canSeeExcelExport) return null;

  const disabled = !refs || exportMutation.isPending;

  return (
    <div className="flex flex-col items-end" data-testid="export-button">
      <Button
        variant="outline"
        size="sm"
        onClick={() => exportMutation.mutate()}
        disabled={disabled}
        title="Экспорт в Excel"
      >
        {exportMutation.isPending ? <Spinner /> : <Download className="h-4 w-4" />}
        Экспорт в Excel
      </Button>
      {exportMutation.isError && (
        <span className="mt-0.5 text-[11px] text-destructive">
          Не удалось выгрузить.
        </span>
      )}
    </div>
  );
}
